import { Paper } from '@mui/material';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import PropTypes from 'prop-types';
import * as React from 'react';
import * as Redux from 'react-redux';
import { setActivoDireccionesAction } from '../../direcciones/DireccionesAction';
import FormDirecciones from '../../direcciones/components/FormDirecciones';
import FormEntidades from '../../entidad/entidades/components/FormEntidades';
import { setActivoTelefonosAction } from '../../telefonos/TelefonosAction';
import EntMonedasView from '../ent_monedas/EntMonedasView';
import FormEntAjustes from './components/FormEntAjustes';
import FormEntImagenes from './components/FormEntImagenes';

export function TabPanel(props) {
  const templateStore = Redux.useSelector((state) => state.template);

  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box
          sx={{
            width: templateStore.settings.openSidebar ? '60vw' : '78vw',
            p: 3,
          }}
        >
          {' '}
          {children}{' '}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const EntAjustesComponent = () => {
  const dispatch = Redux.useDispatch();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);

  const [value, setValue] = React.useState(0);

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };

  function getDataEntidad() {
    if (!entidadesStore.activo) return;
    setActivoDireccionesAction(dispatch, entidadesStore.activo.direccion);
    setActivoTelefonosAction(dispatch, entidadesStore.activo.telefono);
  }

  React.useEffect(() => {
    getDataEntidad();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    getDataEntidad();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entidadesStore.activo]);

  const views = [
    {
      name: 'Información',
      view: <FormEntidades isAjustes />,
    },
    {
      name: 'Imágenes',
      view: <FormEntImagenes />,
    },
    {
      name: 'Dirección',
      view: (
        <FormDirecciones params={{ idEntidad: entidadesStore.activo.id }} />
      ),
    },
    {
      name: 'Parámetros',
      view: <FormEntAjustes />,
    },
  ];

  if (loginStore.isAdmin) {
    views.push(
      ...[
        {
          name: 'Monedas',
          view: <EntMonedasView />,
        },
      ],
    );
  }

  // if (loginStore.isRoot) {
  //   views.push(
  //     ...[
  //       {
  //         name: 'Carnet',
  //         view: <CarnetView />,
  //       },
  //     ],
  //   );
  // }

  return (
    <Paper elevation={4}>
      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
        }}
      >
        <Tabs
          orientation="vertical"
          variant="scrollable"
          value={value}
          onChange={handleChange}
          aria-label="Ajustes"
          sx={{ borderRight: 1, borderColor: 'divider' }}
        >
          {views.map((e, i) => {
            return (
              <Tab
                key={`tabs_${i}`}
                label={e.name}
                sx={{
                  width: '200px',
                }}
                {...a11yProps(i)}
              />
            );
          })}
        </Tabs>
        {views.map((e, i) => {
          return (
            <TabPanel value={value} key={i} index={i}>
              {e.view}
            </TabPanel>
          );
        })}
      </Box>
    </Paper>
  );
};

export default EntAjustesComponent;
